// extracted by mini-css-extract-plugin
export default {"sentinel":"footer_sentinel__kIA21","fab":"footer_fab__ahKcN","fabHidden":"footer_fabHidden__reNfh","icon":"footer_icon__EBkaV"};